import { render, staticRenderFns } from "./icon-plus.vue?vue&type=template&id=18156d8c&scoped=true"
import script from "./icon-plus.vue?vue&type=script&lang=js"
export * from "./icon-plus.vue?vue&type=script&lang=js"
import style0 from "./icon-plus.vue?vue&type=style&index=0&id=18156d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18156d8c",
  null
  
)

export default component.exports